
import project from '../../../project'
// import { Tracking } from '../../../../NodeModules/nnd-track-page'

import Barchart from '../../components/Barchart'

const Tracking = {
  trackPageImpression: function (page, id) {
    const pageID = `nnd-${id.trim().replace(/ /g, '').toLocaleLowerCase()}`
    const pageNAME = page.trim().replace(/ /g, '_').toLocaleLowerCase()
    if (process.env.NODE_ENV === 'production' && typeof window.mready !== 'undefined' && typeof window.utag_data !== 'undefined') {
      try {
        window['utag_data'] = window['utag_data'] || {}
        window['mready'] = window['mready'] || []
        window['mready']['push'](function (metrics) {
          metrics['ev']({
            'events': ['event9'],
            'eVar25': [pageID, pageNAME].join(' | ').replace(/\|/g, ':').toLocaleLowerCase()
          })
        })
      } catch (e) {
        try {
          if (typeof window.console !== 'undefined' && typeof window.console.warn !== 'undefined') {
            window.console.warn('Logging error (mready): ', e.message)
          }
        } catch (ee) { }
      }
    }
  }
}

export default {
  name: `home`,
  components: { Barchart },
  data () {
    return {
      teams: {
        pool: {
          'a': [
            { country: 'Ireland', place: null, flag: 'ire' },
            { country: 'Scotland', place: null, flag: 'sco' },
            { country: 'Japan', place: null, flag: 'jpn' },
            { country: 'Russia', place: null, flag: 'rus' },
            { country: 'Samoa', place: null, flag: 'sam' }
          ],
          'b': [
            { country: 'New Zealand', place: null, flag: 'nz' },
            { country: 'South Africa', place: null, flag: 'rsa' },
            { country: 'Italy', place: null, flag: 'ita' },
            { country: 'Namibia', place: null, flag: 'nam' },
            { country: 'Canada', place: null, flag: 'can' }
          ],
          'c': [
            { country: 'England', place: null, flag: 'eng' },
            { country: 'France', place: null, flag: 'fra' },
            { country: 'Argentina', place: null, flag: 'arg' },
            { country: 'United States', place: null, flag: 'usa' },
            { country: 'Tonga', place: null, flag: 'ton' }
          ],
          'd': [
            { country: 'Australia', place: null, flag: 'aus' },
            { country: 'Wales', place: null, flag: 'wal' },
            { country: 'Georgia', place: null, flag: 'geo' },
            { country: 'Fiji', place: null, flag: 'fij' },
            { country: 'Uruguay', place: null, flag: 'uru' }
          ]
        },
        poolSelected: {
          'a': [1, 'Select 1st place'],
          'b': [1, 'Select 1st place'],
          'c': [1, 'Select 1st place'],
          'd': [1, 'Select 1st place']
        },
        quarterfinal: {
          'a': [
            { country: 'Select', winner: false, flag: null },
            { country: 'Select', winner: false, flag: null }
          ],
          'b': [
            { country: 'Select', winner: false, flag: null },
            { country: 'Select', winner: false, flag: null }
          ],
          'c': [
            { country: 'Select', winner: false, flag: null },
            { country: 'Select', winner: false, flag: null }
          ],
          'd': [
            { country: 'Select', winner: false, flag: null },
            { country: 'Select', winner: false, flag: null }
          ]
        },
        quarterfinalSelected: {
          'a': [0, ''],
          'b': [0, ''],
          'c': [0, ''],
          'd': [0, '']
        },
        semifinal: {
          'a': [
            { country: 'Select', winner: false, flag: null },
            { country: 'Select', winner: false, flag: null }
          ],
          'b': [
            { country: 'Select', winner: false, flag: null },
            { country: 'Select', winner: false, flag: null }
          ]
        },
        semifinalSelected: {
          'a': [0, ''],
          'b': [0, '']
        },
        final: {
          'a': [
            { country: 'Select', winner: false, flag: null },
            { country: 'Select', winner: false, flag: null }
          ]
        },
        finalSelected: {
          'a': [0, '']
        },
        winner: {
          'a': [
            { country: 'Select', winner: false, flag: null }
          ]
        },
        winnerSelected: {
          onceSelected: false,
          country: null,
          data: {
            data: [],
            dataPerc: { 'ire': 0, 'sco': 0, 'jpn': 0, 'rus': 0, 'sam': 0, 'nz': 0, 'rsa': 0, 'ita': 0, 'nam': 0, 'can': 0, 'eng': 0, 'fra': 0, 'arg': 0, 'usa': 0, 'ton': 0, 'aus': 0, 'wal': 0, 'geo': 0, 'fij': 0, 'uru': 0 },
            totalVotes: 0
          }
          // country: { country: 'Australia', winner: true, flag: 'aus' }
          // country: { country: null, winner: null, flag: null, perc: null }
        },
        roundsPositions: {
          poolPosition: {
            'a_1': 'd_1',
            'a_2': 'b_2',
            'b_1': 'b_1',
            'b_2': 'd_2',
            'c_1': 'a_1',
            'c_2': 'c_2',
            'd_1': 'c_1',
            'd_2': 'a_2'
          },
          quarterfinalPosition: {
            'a_1': 'a_1',
            'b_1': 'a_2',
            'c_1': 'b_1',
            'd_1': 'b_2'
          },
          semifinalPosition: {
            'a_1': 'a_1',
            'b_1': 'a_2'
          },
          finalPosition: {
            'a_1': 'a_1'
          }
        }
      }
    }
  },
  methods: {
    getImgUrl (img, type) {
      return require('../../assets/images/' + img + '.' + type)
      // return require('../../assets/images/rating_' + img + '_' + type + '.jpg')
    },
    getTeamName (round, pool) {
      return `nnd-${round}-team-${pool}`
    },
    removeTeams (roundGroup, roundThis, rounds) {
      const vm = this
      let thisRoundGroup = vm.teams.roundsPositions[`${roundThis}Position`][roundGroup].split('_')
      thisRoundGroup[1] = (parseInt(thisRoundGroup[1], 10) - 1)
      vm.teams[rounds[0]][thisRoundGroup[0]][thisRoundGroup[1]].country = 'Select'
      vm.teams[rounds[0]][thisRoundGroup[0]][thisRoundGroup[1]].flag = null
      vm.teams[rounds[0]][thisRoundGroup[0]][thisRoundGroup[1]].winner = false
      vm.teams[rounds[0]][thisRoundGroup[0]][thisRoundGroup[1]][roundGroup] = ''
      // vm.teams[rounds[0]][thisRoundGroup[0]][thisRoundGroup[1]] = {
      //   country: 'Select',
      //   flag: null,
      //   winner: false
      // }
      vm.teams[rounds[0]][thisRoundGroup[0]][((thisRoundGroup[1] === 0) ? 1 : 0)]['winner'] = false

      vm.teams[`${rounds[0]}Selected`][thisRoundGroup[0]][0] = 0
      for (let i = 0; i < vm.teams[rounds[0]][thisRoundGroup[0]].length; i++) {
        if (vm.teams[rounds[0]][thisRoundGroup[0]][i].flag !== null) {
          vm.teams[`${rounds[0]}Selected`][thisRoundGroup[0]][0] += 1
        }
      }
      if (vm.teams[`${rounds[0]}Selected`][thisRoundGroup[0]][0] === 2) {
        vm.teams[`${rounds[0]}Selected`][thisRoundGroup[0]][1] = 'Select'
      } else if (vm.teams[`${rounds[0]}Selected`][thisRoundGroup[0]][0] < 2) {
        vm.teams[`${rounds[0]}Selected`][thisRoundGroup[0]][1] = ''
      }

      roundThis = rounds[0]
      rounds.splice(0, 1)
      if (rounds.length > 0) {
        return vm.removeTeams(`${thisRoundGroup[0]}_1`, roundThis, rounds)
      } else {
        vm.teams.winnerSelected.country = null
      }
      /*
      const vm = this
      let thisGroup = `${groupName}_${d.place}`
      let thisRoundGroup = vm.teams.roundsPositions[`${roundThis}Position`][thisGroup].split('_')
      thisRoundGroup[1] = (parseInt(thisRoundGroup[1], 10) - 1)
      vm.teams[roundNext][thisRoundGroup[0]][thisRoundGroup[1]] = {
        country: 'Select',
        flag: null,
        winner: false
      }
      vm.teams[roundNext][thisRoundGroup[0]][((thisRoundGroup[1] === 0) ? 1 : 0)]['winner'] = false
      */
    },
    nextEnableDisable (thisRound) {
      const vm = this
      let totalTeamsSelected = {
        total: 0,
        teams: []
      }
      for (let key in vm.teams[thisRound]) {
        vm.teams[`${thisRound}Selected`][key][0] = 0
        let isTeamSelected = false
        for (let i = 0; i < vm.teams[thisRound][key].length; i++) {
          if (vm.teams[thisRound][key][i].flag !== null) {
            vm.teams[`${thisRound}Selected`][key][0] += 1
            if (vm.teams[thisRound][key][i].winner) {
              totalTeamsSelected.teams.push([key + (i + 1), vm.teams[thisRound][key][i].flag].join('_'))
              totalTeamsSelected.total += 1
              isTeamSelected = true
            }
          }
        }
        if (vm.teams[`${thisRound}Selected`][key][0] === 2) {
          vm.teams[`${thisRound}Selected`][key][1] = 'Select'
        } else if (vm.teams[`${thisRound}Selected`][key][0] < 2) {
          vm.teams[`${thisRound}Selected`][key][1] = ''
        }
        if (isTeamSelected) {
          vm.teams[`${thisRound}Selected`][key][1] = 'Selected'
        }
      }
      if ((thisRound === 'quarterfinal' && totalTeamsSelected.total === 4) || (thisRound === 'semifinal' && totalTeamsSelected.total === 2) || (thisRound === 'final' && totalTeamsSelected.total === 1)) {
        Tracking.trackPageImpression(`${thisRound.charAt(0)}_${totalTeamsSelected.teams.join('-')}`, project.name)
      }
    },
    selectWinningTeam (d, groupName, roundThis, roundNext) {
      const vm = this
      // If two teams are not yet selected
      // or clicked on the losing team
      // do nothing
      if (vm.teams[`${roundThis}Selected`][groupName][0] !== 2 || d.flag === null || d.winner) {
        return false
      }
      // if nothing matches above then execute this
      // Select winning team
      for (let i = 0; i < vm.teams[roundThis][groupName].length; i++) {
        // if (vm.teams[roundThis][groupName][i]['place']) {
        if (d.flag === vm.teams[roundThis][groupName][i]['flag']) {
          vm.teams[roundThis][groupName][i]['winner'] = true
          let thisTeam = `${groupName}_1`
          for (let key in vm.teams.roundsPositions[`${roundThis}Position`]) {
            if (key === thisTeam) {
              let splitKey = vm.teams.roundsPositions[`${roundThis}Position`][key].split('_')
              splitKey[1] = (parseInt(splitKey[1], 10) - 1)
              vm.teams[roundNext][splitKey[0]][splitKey[1]]['country'] = vm.teams[roundThis][groupName][i]['country']
              vm.teams[roundNext][splitKey[0]][splitKey[1]]['flag'] = vm.teams[roundThis][groupName][i]['flag']
              vm.teams[roundNext][splitKey[0]][splitKey[1]]['winner'] = false
              vm.teams[roundNext][splitKey[0]][splitKey[1]][`${roundThis}Group`] = thisTeam
              if (roundThis !== 'final') {
                vm.teams[roundNext][splitKey[0]][((splitKey[1] === 0) ? 1 : 0)]['winner'] = false
              }
            }
          }
        } else {
          vm.teams[roundThis][groupName][i]['winner'] = false
        }
      }
      // let thisGroup = `${groupName}_1`
      // vm.removeTeams(thisGroup, roundThis, ['semifinal', 'final'])
      vm.nextEnableDisable(roundThis)
      if (roundThis === 'final') {
        // vm.teams.winnerSelected.onceSelected = true
        vm.teams.winnerSelected.country = d

        // let scrollEl = document.getElementsByClassName('nnd-final-cont')
        // console.log(scrollEl)
        // window.scrollTo({ top: (scrollEl.offsetTop + scrollEl.offsetHeight - 40), behavior: 'smooth' })

        setTimeout(() => {
          let barchartEl = document.getElementById('nndrugbyworldcup2019barchart')
          if (barchartEl.offsetWidth < 800) {
            window.scrollTo({ top: (barchartEl.offsetTop - 10), behavior: 'smooth' })
          }
        }, 300)
      } else {
        vm.nextEnableDisable(roundNext)

        if (roundNext === 'semifinal') {
          let thisGroup = `${groupName}_1`
          thisGroup = vm.teams.roundsPositions['quarterfinalPosition'][thisGroup].split('_')[0] + '_1'
          thisGroup = vm.teams.roundsPositions['semifinalPosition'][thisGroup]
          let finalGroupItem = parseInt(thisGroup.split('_')[1], 10)

          vm.teams.final.a[finalGroupItem - 1].country = 'Select'
          vm.teams.final.a[finalGroupItem - 1].flag = null
          vm.teams.final.a[finalGroupItem - 1].winner = false
          vm.teams.final.a[finalGroupItem - 1].semifinalGroup = ''

          vm.teams.final.a[finalGroupItem === 1 ? 1 : 0].winner = false

          vm.teams[`finalSelected`].a[0] = 0
          let isTeamSelected = false
          for (let i = 0; i < vm.teams.final.a.length; i++) {
            if (vm.teams.final.a[i].flag !== null) {
              vm.teams[`finalSelected`].a[0] += 1
              if (vm.teams.final.a[i].winner) {
                isTeamSelected = true
              }
            }
          }
          if (vm.teams[`finalSelected`].a[0] === 2) {
            vm.teams[`finalSelected`].a[1] = 'Select'
          } else if (vm.teams[`finalSelected`].a[0] < 2) {
            vm.teams[`finalSelected`].a[1] = ''
          }
          if (isTeamSelected) {
            vm.teams[`finalSelected`].a[1] = 'Selected'
          }
        }

        vm.teams.winner.a[0].country = 'Select'
        vm.teams.winner.a[0].flag = null
        vm.teams.winner.a[0].winner = false
        vm.teams.winner.a[0].finalGroup = ''

        vm.teams.winnerSelected.country = null
      }
    },
    goToQuarterFinalLevel (groupName, roundThis, roundNext) {
      const vm = this
      for (let i = 0; i < vm.teams[roundThis][groupName].length; i++) {
        if (vm.teams[roundThis][groupName][i]['place']) {
          let thisTeam = `${groupName}_${vm.teams[roundThis][groupName][i]['place']}`
          for (let key in vm.teams.roundsPositions[`${roundThis}Position`]) {
            if (key === thisTeam) {
              let splitKey = vm.teams.roundsPositions[`${roundThis}Position`][key].split('_')
              splitKey[1] = (parseInt(splitKey[1], 10) - 1)
              if (!vm.teams[roundNext][splitKey[0]][splitKey[1]]['winner']) {
                vm.teams[roundNext][splitKey[0]][splitKey[1]]['country'] = vm.teams[roundThis][groupName][i]['country']
                vm.teams[roundNext][splitKey[0]][splitKey[1]]['flag'] = vm.teams[roundThis][groupName][i]['flag']
                vm.teams[roundNext][splitKey[0]][splitKey[1]]['winner'] = false
                vm.teams[roundNext][splitKey[0]][splitKey[1]][`${roundThis}Group`] = thisTeam
              }
            }
          }
        }
      }
      vm.nextEnableDisable(roundNext)
    },
    removeTeam (d, groupName, roundThis, roundNext) {
      const vm = this
      let thisGroup = `${groupName}_${d.place}`
      let thisRoundGroup = vm.teams.roundsPositions[`${roundThis}Position`][thisGroup].split('_')
      // START
      vm.removeTeams(thisGroup, roundThis, ['quarterfinal', 'semifinal', 'final'])
      // END
      thisRoundGroup[1] = (parseInt(thisRoundGroup[1], 10) - 1)
      vm.teams[roundNext][thisRoundGroup[0]][thisRoundGroup[1]] = {
        country: 'Select',
        flag: null,
        winner: false
      }
      vm.teams[roundNext][thisRoundGroup[0]][((thisRoundGroup[1] === 0) ? 1 : 0)]['winner'] = false
    },
    selectPoolTeam (d, groupName, groupThis, groupNext) {
      const vm = this
      let poolTeams = vm.teams[`${groupThis}Selected`][groupName]
      // If both the positions are already selected
      // If this match is Pool match
      // If Pool match and selected team is not in top 2
      if (poolTeams[0] === 0 && d.place === null) {
        return false
      } else {
        // If this is already selected so remove that team
        if (d.place !== null) {
          if (d.place === 1) {
            poolTeams[1] = 'Select 1st place'
            poolTeams[0] = 1
          } else if (d.place === 2) {
            poolTeams[1] = 'Select 2nd place'
            poolTeams[0] = 2
          }
          // //
          // vm.removeTeam(d, groupName, groupThis, groupNext)
          let thisGroup = `${groupName}_${d.place}`
          vm.removeTeams(thisGroup, groupThis, ['quarterfinal', 'semifinal', 'final'])
          // //
          d.place = null

          // Check if all the items are empty once removing place position from this item
          // If the item removed is in second place and the first place item was already remove earlier
          // This will make it select first place team instead of second place team from above code
          let posEmpty = []
          for (let i = 0; i < vm.teams[groupThis][groupName].length; i++) {
            if (vm.teams[groupThis][groupName][i]['place']) {
              posEmpty.push(vm.teams[groupThis][groupName][i]['place'])
            }
          }
          if (posEmpty.length < 1) {
            poolTeams[1] = 'Select 1st place'
            poolTeams[0] = 1
          }
        } else {
          // Add place value to this team
          d['place'] = poolTeams[0]

          let posEmpty = []
          // let totalTeamsSelected = 0 // for tracking
          for (let i = 0; i < vm.teams[groupThis][groupName].length; i++) {
            if (vm.teams[groupThis][groupName][i]['place']) {
              posEmpty.push(vm.teams[groupThis][groupName][i]['place'])
            }
          }
          if (posEmpty.length < 2) {
            poolTeams[0] = Math.min(...posEmpty)
            if (poolTeams[0] === 1) {
              poolTeams[1] = 'Select 2nd place'
              poolTeams[0] = 2
            } else {
              poolTeams[1] = 'Select 1st place'
              poolTeams[0] = 1
            }
          } else {
            poolTeams[1] = 'Teams selected'
            poolTeams[0] = 0
          }
          // if (totalTeamsSelected ) {
          //   Tracking.trackPageImpression(thisRound, project.name)
          // }
        }
        vm.goToQuarterFinalLevel(groupName, groupThis, groupNext)
      }
    }
  },
  mounted () {
    // console.clear()
  }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/home.js